import { useState } from "react";

export default function Cta() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((v, k) => data.append(k, v as string));
    try {
      await fetch("https://readdy.ai/api/form/d71p5mmuimmp87kg1lf0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="reserve" className="py-24 bg-[#3a4a28] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://public.readdy.ai/ai/img_res/82ead3a069cb5a5fd1eb18d1a61b5617.jpg)",
        }}
      />
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <p className="text-white/40 text-xs tracking-[0.4em] mb-6">RESERVATION</p>
        <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight mb-4">
          まずは一度、<br />身体を整える体験を。
        </h2>
        <p className="text-white/70 text-sm leading-loose mb-12 tracking-wide">
          無理なく、今の状態に合わせてご案内します。<br />
          ご不明な点はお気軽にLINEでもご相談ください。
        </p>

        {submitted ? (
          <div className="bg-white/15 rounded-lg px-10 py-12 text-white">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-checkbox-circle-line text-4xl text-white/80" />
            </div>
            <p className="font-serif text-xl mb-2">ご予約を受け付けました</p>
            <p className="text-white/70 text-sm tracking-wide">確認のご連絡を差し上げます。しばらくお待ちください。</p>
          </div>
        ) : (
          <form
            id="kuu-reservation-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-left space-y-5"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="text-white/70 text-xs tracking-wider block mb-2">お名前 *</label>
                <input
                  name="name"
                  required
                  type="text"
                  placeholder="例：山田 花子"
                  className="w-full bg-white/15 border border-white/25 rounded-sm px-4 py-3 text-white placeholder-white/40 text-sm focus:outline-none focus:border-white/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-white/70 text-xs tracking-wider block mb-2">メールアドレス *</label>
                <input
                  name="email"
                  required
                  type="email"
                  placeholder="例：example@email.com"
                  className="w-full bg-white/15 border border-white/25 rounded-sm px-4 py-3 text-white placeholder-white/40 text-sm focus:outline-none focus:border-white/60 transition-colors"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="text-white/70 text-xs tracking-wider block mb-2">電話番号</label>
                <input
                  name="phone"
                  type="tel"
                  placeholder="例：090-0000-0000"
                  className="w-full bg-white/15 border border-white/25 rounded-sm px-4 py-3 text-white placeholder-white/40 text-sm focus:outline-none focus:border-white/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-white/70 text-xs tracking-wider block mb-2">ご希望のメニュー</label>
                <select
                  name="menu"
                  className="w-full bg-[#3a4a28] border border-white/25 rounded-sm px-4 py-3 text-white text-sm focus:outline-none focus:border-white/60 transition-colors cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option>オーダーメイド施術</option>
                  <option>スポーツ整体</option>
                  <option>頭蓋骨矯正</option>
                  <option>パーソナルトレーニング</option>
                  <option>キックボクシングパーソナル</option>
                  <option>未定・相談したい</option>
                </select>
              </div>
            </div>
            <div>
              <label className="text-white/70 text-xs tracking-wider block mb-2">ご希望日時・メッセージ</label>
              <textarea
                name="message"
                rows={4}
                maxLength={500}
                placeholder="ご希望の日時（複数可）や、体のお悩みなどをご記入ください。"
                className="w-full bg-white/15 border border-white/25 rounded-sm px-4 py-3 text-white placeholder-white/40 text-sm focus:outline-none focus:border-white/60 transition-colors resize-none"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-[#3a4a28] py-4 text-sm tracking-[0.2em] font-medium hover:bg-white/90 transition-colors cursor-pointer rounded-sm whitespace-nowrap disabled:opacity-60"
            >
              {loading ? "送信中..." : "予約リクエストを送る"}
            </button>
            <p className="text-white/40 text-xs text-center tracking-wide">
              ご予約確定後、メールにてご連絡いたします。
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
